export const POST_QUESTION_LOADING = "POST_QUESTION_LOADING";

export const POST_QUESTION_SUCCESS = "POST_QUESTION_SUCCESS";

export const POST_QUESTION_ERROR = "POST_QUESTION_ERROR";

export const GET_QUESTION_LOADING = "GET_QUESTION_LOADING";

export const GET_QUESTION_SUCCESS = "GET_QUESTION_SUCCESS";

export const GET_QUESTION_ERROR = "GET_QUESTION_ERROR";

export const DELETE_QUESTION_LOADING = "DELETE_QUESTION_LOADING";

export const DELETE_QUESTION_SUCCESS = "DELETE_QUESTION_SUCCESS";

export const DELETE_QUESTION_ERROR = "DELETE_QUESTION_ERROR";